export default __webpack_public_path__ + "static/media/Collections-Logo__Mutant-Ape-Yac.f7f37f3c.png";